import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async thunks
export const fetchLoves = createAsyncThunk(
  'loves/fetchLoves',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/loves');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch loves');
    }
  }
);

export const removeLove = createAsyncThunk(
  'loves/removeLove',
  async (loveId, { rejectWithValue }) => {
    try {
      await api.delete(`/loves/${loveId}`);
      return loveId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to remove love');
    }
  }
);

// Initial state
const initialState = {
  items: [],
  loading: false,
  error: null,
};

// Slice
const lovesSlice = createSlice({
  name: 'loves',
  initialState,
  reducers: {
    clearLovesError: (state) => {
      state.error = null;
    },
    resetLoves: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch loves
      .addCase(fetchLoves.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoves.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchLoves.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Remove love
      .addCase(removeLove.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeLove.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter(item => item.id !== action.payload);
      })
      .addCase(removeLove.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLovesError, resetLoves } = lovesSlice.actions;
export default lovesSlice.reducer;
